import TemplateFull from '../../layout/TemplateFull';
import AddressRoot from '../../components/pages/Address';

const Address = () => {
  return (
    <TemplateFull>
      <AddressRoot />
    </TemplateFull>
  );
};

export default Address;
